<!--
 * A Vue component for switch organizations within a cooperation
 *
 *
 * Properties
 * ==========
 * - organizationId -
 * (Required) The current organization id
 * - organizations -
 * (Required) The organizations within the cooperation.
-->
<template>
    <div>
        <b-form-select
            :value="organizationId"
            @change="changeOrganization($event)"
            :options="organizations"
        >
        </b-form-select>
    </div>
</template>

<script>
    export default {
        name: 'CooperationOrganizationSwitcher',
        inheritAttrs: false,

        props: {
            // current selected organization if
            organizationId: { type: Number, required: true },
            // list of available organizations
            organizations: { type: Array, required: true },
        },

        data() {
            return {
            };
        },

        methods: {

            async changeOrganization(event) {
                if (event) {
                    const selectedOrganization = {
                        organizationId: event,
                    };
                    // emit organization chaged event
                    this.$emit('changed-organization', selectedOrganization);
                }
            }
        }
    };
</script>
